import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import "babel-polyfill";
import VueMask from "v-mask";
import { Auth0Plugin } from "./auth";
import { domain, clientId, audience } from "./auth_config.json";
import notification from "./plugins/notification";
import { registerLicense } from "@syncfusion/ej2-base";
import GlobalWrapperComponents from "./plugins/global-wrapper-components";
registerLicense(
  "ORg4AjUWIQA/Gnt2VVhkQlFac1xJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxQdk1iW39bc3FUR2ZeV0A="
);
//import VueAppInsights from "vue-application-insights";
import LoaderPlugin from "./plugins/loaderPlugin";
import LocalLoaderPlugin from "./plugins/localLoaderPlugin";

Vue.use(VueMask);
Vue.use(LoaderPlugin, { vuetify, i18n });
Vue.use(LocalLoaderPlugin, { vuetify, i18n });

Vue.config.productionTip = false;

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  useRefreshTokens: true,
  cacheLocation: "localstorage",
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  },
});

/*
// comment for this release only
Vue.use(VueAppInsights, {
  id: process.env.VUE_APP_INSIGHTS_KEY,
  autoTrackPageVisitTime: true,
  enableAutoRouteTracking: true,
  router,
});
*/

const myApp = new Vue({
  router,
  store,
  vuetify,
  i18n,
  GlobalWrapperComponents,
  render: (h) => h(App),
}).$mount("#app");

export default myApp;
